import Link from 'next/link';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { ButtonClose } from '@/components/buttons';
import { ImageComponent } from '@/components/Image';

import { ScKnowYourLimitModal, ScKnowYourLimitModalWrapper } from './styled';

interface IKnowYourLimitProps {
  onClose?: () => void;
}

export const KnowYourLimitModal: React.FC<IKnowYourLimitProps> = ({
  onClose,
}) => {
  const { t } = useTranslation('common');

  return (
    <ScKnowYourLimitModalWrapper>
      <ScKnowYourLimitModal>
        <ButtonClose gray onClick={onClose} top={1} right={1} />
        <ImageComponent
          src="/responsible-gaming.png"
          alt="responsible-gaming"
          width={80}
          height={80}
        />
        <p className="title">{t('knowYourLimit.title')}</p>
        <p>
          <Trans
            i18nKey="knowYourLimit.description"
            components={{
              1: <Link href="/profile-custom/limits" />,
            }}
          />
        </p>
      </ScKnowYourLimitModal>
    </ScKnowYourLimitModalWrapper>
  );
};
